var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h1 my-2"},[_vm._v("産品管理")]),_vm._v(" "),_c('span',{staticClass:"mb-2 d-flex"},[_c('product-editor',{attrs:{"categories":_vm.categories},on:{"product:created":_vm.productCreated}},[_vm._v("Create Product")])],1),_vm._v(" "),_c('product-list',{ref:"products",attrs:{"categories":_vm.categories}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }